import React from "react";
import { Navigate } from "react-router-dom";

import Profile from "../profile/Profile";
import { useGetLandingCreatorQuery } from "../../app/services/publicCreators";
import { getAuthTokenFromCookies } from "../../common/utils";

/**
 * サイトトップ（`soremo.jp/`）。旧 Django 環境の「ランディングアカウント
 * （settings.ARTIST_MAIL_LANDINGPAGE）の公開プロフィールをルートに表示する」
 * 挙動を引き継ぐ。
 *
 * - ログイン済み（auth_token cookie あり）はプロジェクト一覧へ
 *   （旧環境の「ログイン済みはワークスペースへ」の踏襲）。
 * - 未ログインは `GET /api/landing-profile` のプロフィールを表示する。
 *   未設定・取得失敗時は従来どおりサインインへフォールバックする。
 */
const RootLanding: React.FC = () => {
  const isAuthenticated = !!getAuthTokenFromCookies();
  const { isLoading, isError } = useGetLandingCreatorQuery(undefined, {
    skip: isAuthenticated,
  });

  if (isAuthenticated) {
    return <Navigate to="/projects" replace />;
  }
  if (isLoading) {
    return (
      <div className="u-col-center u-w100" style={{ minHeight: "60vh" }}>
        <span className="bodytext-13 u-text-light-gray">読み込み中...</span>
      </div>
    );
  }
  if (isError) {
    return <Navigate to="/signin" replace />;
  }
  return <Profile landing />;
};

export default RootLanding;
